import { RootState } from "store";

/**
 * Stop persisting auth tokens in localStorage (redux-persist `persist:root`).
 * Auth slice is now blacklisted; this migration clears any previously stored auth.
 */
const migration3 = (state: RootState) => {
  return {
    ...state,
    auth: {
      isAuthenticated: false,
      isLoading: false,
      error: null,
      accessToken: null,
      globalError: null,
      user: null,
    },
  };
};

export default migration3;
